module.exports = __webpack_public_path__ + "01_glasses_red.bbee3f41.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer4/01_glasses_red.png
// module id = jQuv
// module chunks = 0